import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'

import { SectionField } from '../../Inputs/SectionField'
import { PrivacyInput } from './PrivacyInput'
import { CategoryField } from '../Hero/CategoryField'
import { EventHookInterface } from '../../../types'
import { forScreensGreaterThanMobileWidth, mobileScreen } from '../../../utils'

// Div.
const Div = styled.div`
  display: flex;
  column-gap: 20px;

  flex-direction: row;

  ${mobileScreen(css`
    flex-direction: column;
  `)}

  .categoryField {
    margin-bottom: 30px;
  }

  .formField {
    margin-bottom: 20px;
    text-align: left;
    width: 100%;
  }

  .formField:last-child {
    margin-bottom: 0;
  }

  .selectInput {
    width: 100%;
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Event Size Field.
export const EventSizeField: React.FC<Props> = ({ eventHook }) => {
  const { t } = useTranslation('common')

  return (
    <SectionField
      header={t(`Public or unlisted?`, `Public or unlisted?`)}
      subheader={t(
        `EventSizeField-160962626`,
        `Select whether your event is public or hidden. If 'public' Klyk will boost your event as a recommended listing across the platform.`,
      )}>
      <Div>
        {/* Public/Hidden. */}
        <PrivacyInput eventHook={eventHook} />

        {/* Category. */}
        <CategoryField eventHook={eventHook} />
      </Div>
    </SectionField>
  )
}
